import axios from "axios";

const API_URL = "/api/v1/beam";

export const BeamService = {
  /**
   * ดึงรายการธุรกรรม Beam พร้อมตัวกรอง
   * @param {Object} params 
   * @param {string} params.filterType - 'day' | 'month' | 'range'
   * @param {string} [params.date] - YYYY-MM-DD
   * @param {number} [params.year] - ค.ศ. หรือ พ.ศ.
   * @param {number} [params.month] - 1-12
   * @param {string} [params.startDate] - YYYY-MM-DD
   * @param {string} [params.endDate] - YYYY-MM-DD
   * @param {string} [params.transactionType] - 'PAYMENT' | 'REFUND' | 'VOID' | 'ALL'
   * @param {boolean} [params.filterKioskOnly] - true / false
   * @param {number} [params.limit] - จำนวนรายการ
   */
  getTransactions: (params = {}) => {
    return axios.get(`${API_URL}/transactions`, { params });
  },

  queryTransactions: (data = {}) => {
    return axios.post(`${API_URL}/transactions`, data);
  },

  /**
   * ดึงรายการใบเสร็จรับเงิน PaymentType = 3 (PromptPay) จากระบบ Softcon โดยตรง (ไม่ผ่าน Beam API)
   * @param {Object} params
   * @param {string} [params.date] - YYYY-MM-DD
   * @param {string} [params.status] - 'all' | 'unassigned' | 'assigned'
   */
  getPaymentType3Receipts: (params = {}) => {
    return axios.get(`${API_URL}/receipts`, { params });
  },

  /**
   * บันทึกออกเลขเล่มที่และเลขที่ใบเสร็จ (BookNum/DocNum) และผู้ออกใบเสร็จ (RecorderKey) ลงในตาราง ReceiptHeader
   * @param {Object} data
   * @param {string} data.startBookNum - เล่มที่เริ่มต้น เช่น "1002"
   * @param {string} data.startDocNum - เลขที่เริ่มต้น เช่น "8" หรือ "08"
   * @param {number} [data.recorderKey] - PersonKey ของผู้ออกใบเสร็จ
   * @param {Array<number>} data.receiptHeaderKeys - รายการ ReceiptHeaderKey ที่เลือก
   */
  assignReceiptNumbers: (data = {}) => {
    return axios.post(`${API_URL}/receipts/assign-number`, data);
  },

  /**
   * ดึงรายชื่อผู้ออกใบเสร็จ (RecorderKey) จาก ReceiptHeader ย้อนหลัง 1 ปี
   */
  getReceiptRecorders: () => {
    return axios.get(`${API_URL}/receipts/recorders`);
  },

  /**
   * เปลี่ยนผู้ออกใบเสร็จ (RecorderKey) รายบุคคลในตาราง ReceiptHeader (เปลี่ยนได้แม้จะออกเลขใบเสร็จแล้ว)
   * @param {Object} data
   * @param {number} data.receiptHeaderKey - ReceiptHeaderKey ของใบเสร็จ
   * @param {number} data.recorderKey - PersonKey ของผู้ออกใบเสร็จคนใหม่
   */
  updateReceiptRecorder: (data = {}) => {
    return axios.post(`${API_URL}/receipts/update-recorder`, data);
  }
};

